export default __webpack_public_path__ + "static/media/laundry2-after-2048w.5f2d2963.webp";